import { render, staticRenderFns } from "./ListPublications.vue?vue&type=template&id=0a7cdc68"
import script from "./ListPublications.vue?vue&type=script&lang=js"
export * from "./ListPublications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports